import { Api } from "../Api";
import { IProfile } from "../models/IProfile";

class ProfileApi {

  static update = async (profile: IProfile, email: string, userid: string, signal?: AbortSignal): Promise<boolean> => {
    return Api.Put<boolean>(`api/account`, {
      ...profile,
      email,
      userid
    }, signal);
  }

}

export { ProfileApi }
